<!--
 * @Author: 田鑫
 * @Date: 2021-08-09 20:08:49
 * @LastEditors: 田鑫
 * @LastEditTime: 2021-08-09 22:46:28
 * @Description: 文章管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康在线</el-breadcrumb-item>
        <el-breadcrumb-item>文章管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px" ref="form">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="分类：" prop="categoryId">
              <el-select clearable style="width: 100%" v-model="listParams.categoryId" placeholder="请选择分类" @change="handleCategoryChange">
                <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签：" prop="categoryTagId">
              <el-select clearable style="width: 100%" v-model="listParams.categoryTagId" placeholder="请选择标签">
                <el-option v-for="(item, index) in categoryTagList" :key="index" :label="item.tagName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态：" prop="status">
              <el-select clearable style="width: 100%" v-model="listParams.status" placeholder="请选择状态">
                <el-option v-for="(item, index) in statusList" :key="index" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="标题：" prop="title">
              <el-input v-model="listParams.title" placeholder="请输入文章标题"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label=" ">
              <el-button @click="resetForm">重置</el-button>
              <el-button @click="loadTableData" type="primary">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate">新增文章</el-button>

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" label="序号" width="60">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"></span>
          </template>
        </el-table-column>

        <el-table-column prop="categoryName" align="center" label="分类名称"> </el-table-column>
        <el-table-column prop="categoryTagName" align="center" label="标签名称"> </el-table-column>
        <el-table-column prop="title" align="center" label="文章名称">
          <template slot-scope="scope">
            <span style="color: #22bb52">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="readNum" align="center" label="阅读量"> </el-table-column>
        <el-table-column prop="title" align="center" label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.status === 0">草稿</span>
            <span style="color: #22bb52" v-show="scope.row.status === 1">启用</span>
            <span style="color: #ffa500" v-show="scope.row.status === 2">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="source" align="center" label="来源"></el-table-column>
        <el-table-column prop="sort" align="center" label="排序"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="editRow(scope.row)">修改</el-button>
            <confirm-button
              v-if="scope.row.status === 0 || scope.row.status === 2"
              type="text"
              style="margin: 0 10px"
              title="确认要启用该条数据？"
              @confirmed="changeRowStatus(scope.row.id, 1)"
            >
              <span>启用</span>
            </confirm-button>
            <confirm-button
              v-if="scope.row.status === 1"
              type="text"
              style="margin: 0 10px"
              title="确认要禁用该条数据？"
              @confirmed="changeRowStatus(scope.row.id, 2)"
            >
              <span>禁用</span>
            </confirm-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteRow(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1200px">
      <el-form :model="dialogParams" ref="dialogForm" :rules="dialogRules" label-width="120px">
        <el-form-item prop="categoryId" label="分类：">
          <el-select clearable style="width: 100%" v-model="dialogParams.categoryId" placeholder="请选择分类" @change="handleCategoryChange">
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签：" prop="categoryTagId">
          <el-select clearable style="width: 100%" v-model="dialogParams.categoryTagId" placeholder="请选择标签">
            <el-option v-for="(item, index) in categoryTagListOfNew" :key="index" :label="item.tagName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题：" prop="title">
          <el-input v-model="dialogParams.title" placeholder="请输入文章标题"></el-input>
        </el-form-item>
        <el-form-item label="文章缩略图：" prop="thumbnail">
          <oss-uploader @setImage="getThumbnailImage" :previewList="previewList"></oss-uploader>
        </el-form-item>
        <el-form-item label="文章内容：" prop="html">
          <RichTextarea v-if="dialogVisible" class="wang-editor-style" v-model="dialogParams.html" height="400px" />
        </el-form-item>
        <el-form-item label="文章来源：" prop="source">
          <el-input v-model="dialogParams.source" placeholder="请输入文章来源"></el-input>
        </el-form-item>
        <el-form-item label="显示标签文字：" prop="frontLabel">
          <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 标签</el-button>
          <!-- <el-input
            v-model="dialogParams.frontLabel"
            placeholder="请输入显示标签文字"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input-number v-model="dialogParams.sort" placeholder="请输入排序" :min="1" />
        </el-form-item>
        <el-form-item label=" ">
          <div style="text-align: right">
            <el-button @click="dialogCancel">取消</el-button>
            <el-button type="primary" @click="dialogConfirm" :disabled="isDisabled">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        categoryId: "",
        categoryTagId: "",
        status: "",
        title: ""
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      categoryList: [],
      categoryTagList: [],
      categoryTagListOfNew: [],
      statusList: [
        {
          id: 0,
          title: "草稿"
        },
        {
          id: 1,
          title: "启用"
        },
        {
          id: 2,
          title: "禁用"
        }
      ],
      tableLoading: false,
      tableData: [],
      dialogTitle: "",
      dialogVisible: false,
      dialogParams: {
        categoryId: "",
        categoryTagId: "",
        status: "",
        title: "",
        thumbnail: "",
        html: "",
        source: "",
        frontLabel: "",
        video: "",
        sort: 1
      },
      dialogRules: {
        categoryId: [{ required: true, message: "请选择分类", trigger: "change" }],
        categoryTagId: [{ required: true, message: "请选择标签", trigger: "change" }],
        title: [{ required: true, message: "请输入文章名称", trigger: "blur" }],
        thumbnail: [{ required: true, message: "请上传缩略图", trigger: "change" }],
        html: [{ required: true, message: "请输入文章内容", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "change" }]
      },
      uploading: false,
      isDisabled: false,
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      previewList: []
    };
  },
  mounted() {
    this.loadCategoryList();
    this.loadTableData();
  },
  watch: {
    "dialogParams.categoryId": {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadCategoryTagList(val).then((res) => {
            this.categoryTagListOfNew = res;
          });
        }
      }
    }
  },
  methods: {
    // 关闭tag
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/advisory/category/list",
        method: "GET"
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.categoryList = res.body.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async handleCategoryChange() {
      this.listParams.categoryTagId = "";
      this.dialogParams.categoryTagId = "";
      this.categoryTagList = [];
      await this.loadCategoryTagList(this.listParams.categoryId);
    },
    loadCategoryTagList(categoryId) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: global.apiUrl + "/advisory/tag/list",
          method: "GET",
          params: {
            categoryId
          }
        })
          .then((res) => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.categoryTagList = res.body.data;
              resolve(res.body.data);
            } else {
              reject(new Error());
            }
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },
    loadTableData() {
      this.tableLoading = true;
      const params = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/advisory/html/text/list",
        method: "GET",
        params
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data.content;
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoading = false;
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.loadTableData();
    },
    toCreate() {
      this.dynamicTags = [];
      this.dialogParams = this.$options.data().dialogParams;
      this.dialogTitle = "新增文章";
      this.dialogVisible = true;
    },
    async editRow(row) {
      await this.loadCategoryTagList(row.categoryId);
      if (row.frontLabel) {
        this.dynamicTags = row.frontLabel.split(",");
      }
      this.dialogParams = row;
      this.previewList = [this.dialogParams.thumbnail];
      this.dialogTitle = "修改文章";
      this.dialogVisible = true;
    },
    changeRowStatus(id, status) {
      this.$http({
        url: global.apiUrl + "/advisory/html/text/status",
        method: "GET",
        params: {
          id,
          status
        }
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (status === 0 || status === 2) {
              this.$message.success("文章禁用成功");
            } else {
              this.$message.success("文章启用成功");
            }
          }
          this.loadTableData();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    deleteRow(id) {
      this.$http({
        url: global.apiUrl + "/advisory/delete/html/text",
        method: "DELETE",
        params: {
          id
        }
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success("删除成功");
          }
          this.loadTableData();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /**
     * 更新图片
     * @param {*} value
     */
    getThumbnailImage(value) {
      if (value) {
        this.dialogParams.thumbnail = value;
        this.previewList = [this.dialogParams.thumbnail];
      } else {
        this.dialogParams.thumbnail = "";
        this.previewList = [];
      }
    },
    dialogCancel() {
      this.dialogVisible = false;
    },
    dialogConfirm() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.isDisabled = true;
          this.dialogParams.frontLabel = this.dynamicTags.join(",");
          const params = Object.assign({}, this.dialogParams);
          const url = params.id ? "/advisory/edit/html/text" : "/advisory/add/html/text";
          const method = params.id ? "PUT" : "POST";
          this.$http({
            url: global.apiUrl + url,
            method: method,
            body: params
          })
            .then((res) => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success("保存成功");
                this.dialogVisible = false;
                this.loadTableData();
              } else {
              }
              this.isDisabled = false;
            })
            .catch((err) => {
              console.error(err);
              this.isDisabled = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
  .wang-editor-style {
    padding: 0;
  }
}
</style>
